import type { FunctionComponent } from 'react';

export const Welcome: FunctionComponent = () => {
    return null;
};
